(function () {
    "use strict";

    // @ngInject
    function AccountSetupControllerCtor($scope, UsersManager, PhotosUploadManager, CompaniesManager, _,
                                        $injector, AnalyticsService, PopupMessageService, AbTestService, OnboardingService,
                                        $state, AppStates, NavigationService, DeviceService, $log, $translate, $) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'AccountSetupController';

        this._ = _;

        this.PhotosUploadManager = PhotosUploadManager;
        this.CompaniesManager = CompaniesManager;
        this.UsersManager = UsersManager;
        this.AnalyticsService = AnalyticsService;
        this.AbTestService = AbTestService;
        this.OnboardingService  = OnboardingService;
        this.PopupMessageService = PopupMessageService;
        this.$state = $state;
        this.AppStates = AppStates;
        this.NavigationService = NavigationService;
        this.$log = $log;
        this.$translate = $translate;
        this.$ = $;

        this.isMobile = DeviceService.nxSmallBreakpoint();
        this.accountSetupSteps = [
            {
                key: 'service',
                name: 'Services',
                order: 0,
                title: 'COMPANY_SETTING.SETUP._INTRO_HEADER_1_',
                subtitle: 'COMPANY_SETTING.SETUP._INTRO_TEXT_1_',
                cta: 'COMPANY_SETTING.SETUP._CTA_1',
                files: [],
                isMaxCapacity: false,
            },
            {
                key: 'questionnaire',
                name: 'Questionnaires',
                order: 1,
                title: 'COMPANY_SETTING.SETUP._INTRO_HEADER_2_',
                subtitle: 'COMPANY_SETTING.SETUP._INTRO_TEXT_2_',
                cta: 'COMPANY_SETTING.SETUP._CTA_2',
                files: [],
                isMaxCapacity: false,
            },
            {
                key: 'contract',
                name: 'Contracts',
                order: 2,
                title: 'COMPANY_SETTING.SETUP._INTRO_HEADER_3_',
                subtitle: 'COMPANY_SETTING.SETUP._INTRO_TEXT_3_',
                cta: 'COMPANY_SETTING.SETUP._CTA_3',
                files: [],
                isMaxCapacity: false,
            },
            {
                key: 'review',
                name: 'Review',
                order: 3,
                title: 'COMPANY_SETTING.SETUP._REVIEW_AND_SUBMIT_',
                subtitleNoFiles: 'COMPANY_SETTING.SETUP._NO_FILES_YET_',
                subtitleHasFiles: 'COMPANY_SETTING.SETUP._REVIEW_UPLOADS_',
            },
        ];

        this.currentStepIndex = 0;

        this.getStepFromIndex = index => this.accountSetupSteps.find(step => index === step.order);

        this.currentStep = this.getStepFromIndex(this.currentStepIndex);

        this.reviewSteps = this.accountSetupSteps.filter(step => step.files);

        this.maximumFilesPerStep = 10;

        this.user = UsersManager.getCurrUser();
        this.company = this.CompaniesManager.getCurrCompany();

        if (!this.company.wasFullyFetched()) {
            this.loading = true;
            this.company.once('success', function companyFetched() {
                this.updateAllowSetup();
                this.loading = false;

            }.bind(this));
        } else {
            this.updateAllowSetup();
        }

        this.files = [];
        this.numberOfFilesUploading = 0;

        let source=this.user.companyHasSubscription() ? 'member' : 'trialer';
        this.AnalyticsService.trackPageView(this, this.AnalyticsService.analytics_events.account_setup_modal, {companyId: this.company._id, source: source});

        this.isShowWelcomePage = true;
        this.welcomeSteps = [{
                title: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_1_TITLE'),
                subtitle: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_1_SUBTITLE'),
            }, {
                title: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_2_TITLE'),
                subtitle: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_2_SUBTITLE'),
            }, {
                title: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_3_TITLE'),
                subtitle: $translate.instant('COMPANY_SETTING.SETUP._WELCOME_STEP_3_SUBTITLE'),
            }
        ];

    }

    Controllers.AccountSetupController = Class(Controllers.BaseController, {

        constructor: AccountSetupControllerCtor,

        deleteUploadedFile: function deleteUploadedFile(step, fileViewModel, $event) {
            $event.preventDefault();  // Prevents link from activating
            $event.stopPropagation(); // Prevents parent file-uploader from opening file explorer

            fileViewModel.beingDeleted = true;

            if (fileViewModel.uploading) {
                fileViewModel.file.uploadAPI.abort();
            }

            //delete it from the array
            const isNotDeletedFile = file => file.url !== fileViewModel.url
            step.files = step.files.filter(isNotDeletedFile);

            if (step.files.length < this.maximumFilesPerStep) {
                step.isMaxCapacity = false;
                this.shouldShowContinuePopover = false;
            }

            return false;

        },

        uploadedFileCount: function uploadedFileCount() {
            // Returns the total number of uploaded files
            return (
              this.accountSetupSteps
                .filter(step => step.files) // Only steps with files                
                .map(step => step.files.length) // Get the length (fileCount) of each files array
                .reduce((memo, filesCount) => memo + filesCount, 0) // Sum fileCount over each step
            ); 
        },

        computePopoverText: function computePopoverText() {
            return this.$translate.instant('COMPANY_SETTING.SETUP._POPUP_TEXT_');
        },

        updateAllowSetup: function updateAllowSetup() {
            this.allowAccountSetup = this.company && this.company.offer_account_setup && this.user.isCompanyOwner();
        },

        onFilesDropped: function onFilesDroped($files) {
            if (this.checkFilesSize($files)) {
                this.upload($files);
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.company_setup_files_dropped, {companyId: this.company._id});
            }
            else {
                $files = [];
            }
        },

        onFileSelected: function onFileSelected($files) {
            if (this.checkFilesSize($files)) {
                this.upload($files);
                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.company_setup_files_selected, {companyId: this.company._id});
            }
            else {
                $files = [];
            }
        },

        checkFilesSize: function checkFilesSize(files) {
            // 15 MB limit
            var removedLargeFiles = false;
            if (files != null && files.length > 0) {
                var fileSizeLimit = 15 * 1024 * 1024;
                var cleanedFiles = files.filter(function (file) {
                    return file.size <= fileSizeLimit;
                });

                if (cleanedFiles.length < files.length) {
                    if (files.length === 1) {
                        this.PopupMessageService.showErrorAlert('UPLOAD_FILE._ERROR_FILE_TOO_LARGE_');
                    }
                    else {
                        this.PopupMessageService.showErrorAlert('UPLOAD_FILE._ERROR_FILES_TOO_LARGE_');
                    }
                    return false;
                }
                return true;
            }

            if (removedLargeFiles) {
                this.PopupMessageService.showErrorAlert('UPLOAD_FILE._ERROR_FILE_TOO_LARGE_');
            }

        },

        isFirstStep: function isFirstStep() {
            return this.currentStepIndex === 0;
        },

        isLastStep: function isLastStep() {
            return this.currentStepIndex === (this.accountSetupSteps.length - 1);
        },

        nextStep: function nextStep() {
            if (this.isLastStep()) {
                this.$log.error("next step was called on last step");
                return;
            }

            this.currentStepIndex++;

            this.currentStep = this.getStepFromIndex(this.currentStepIndex);

        },

        previousStep: function previousStep() {
            if (this.isFirstStep()) {
                this.$log.error("prev step called on first step");
                return;
            }

            this.currentStepIndex--;

            this.currentStep = this.getStepFromIndex(this.currentStepIndex);

        },

        goToStep: function goToStep(stepIndex) {
            if (stepIndex < 0 || stepIndex >= this.accountSetupSteps.length) {
                this.$log.error("moveToStep called with out of bounds index");
                return;
            }

            this.currentStepIndex = stepIndex;
            this.currentStep = this.getStepFromIndex(this.currentStepIndex);
        },

        createFileViewModel: function createFileModel(setupAsset) {
            var self = this;
            var fileViewModel = {
                instance: self.company, //the instance of the model containing these files
                type: 'setup_asset',
                dontUpdateServer: true,
                uploading: false,
                uploaded: true,
                beingDeleted: false,
                file: null,
                assetType: this.currentStep.key,
                stepIndex: this.currentStepIndex
            };

            this._.extend(fileViewModel, setupAsset);
            return fileViewModel;
        },

        handleMaximumFileCount: function handleMaximumFileCount() {
            this.PopupMessageService.showAlert(
                this.PopupMessageService.severityTypes.info,
                'COMPANY_SETTING.SETUP._FILE_LIMIT_MODAL_TEXT_', 
                () => {
                    this.shouldShowContinuePopover = true;
                });
            this.currentStep.isMaxCapacity = true;

        },

        upload: function upload(files) {
            var self = this;


            if (files && files.length) {
                files.forEach(function (file) {
                    var fileViewModel = self.createFileViewModel({name: file.name});
                    fileViewModel.uploaded = false;
                    //store on the view model the original file object from the browser
                    fileViewModel.file = file;

                    //enrich the fileViewModel with data that is required to upload it to s3j
                    self.PhotosUploadManager.getUpdatedModelData(fileViewModel);

                    if (self.currentStep.files.length >= self.maximumFilesPerStep) {
                        self.handleMaximumFileCount();
                        return;
                    }

                    var promise = self.PhotosUploadManager.uploadPhoto([file], fileViewModel, self);
                    self.numberOfFilesUploading++;
                    fileViewModel.uploading = true;
                    self.files.push(fileViewModel);


                    self.currentStep.files.push(fileViewModel);

                    promise
                        .then(function success() {
                            self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.vendor_uploaded_setup_file_successful, {
                                companyId: self.company._id,
                                key: fileViewModel.key
                            });

                            fileViewModel.url = file.s3Response.url;
                        })
                        .catch(function error(resp) {


                            if (!resp) {
                                //this is a result of a delete of a file during an upload. remove it from the view model since we know the upload stopped
                                //before it was inserted to our company model
                                self.AnalyticsService.track(self, self.AnalyticsService.analytics_events.vendor_deleted_file_while_uploading, {
                                    companyId: self.company._id,
                                    key: fileViewModel.key
                                });
                                fileViewModel.uploadFailedInTheMiddle = true;
                                return;
                            } else {
                                self.PopupMessageService.showAlert(self.PopupMessageService.severityTypes.error, 'COMPANY_SETTING.SETUP._ERROR_UPLOADING_FILE_');
                                var message = 'Error saving the file: ' + fileViewModel.name;
                                self.AnalyticsService.trackError(self, self.AnalyticsService.analytics_events.error_unable_to_add_setup_file_to_company_settings, resp);
                                fileViewModel.uploadFailedInTheMiddle = true;
                            }
                        })
                        .finally(function () {
                            if (fileViewModel.uploadFailedInTheMiddle) {
                                var indexToRemove = self._.findIndex(self.currentStep.files, fileViewModel);
                                self.currentStep.files.splice(indexToRemove, 1);
                            }

                            fileViewModel.uploading = false;
                            fileViewModel.uploaded = true;
                            fileViewModel.instance = null;
                            self.numberOfFilesUploading--;
                        });
                });

            }
        },

        setMeUp: function setMeUp() {
            if (this.numberOfFilesUploading !== 0) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'COMPANY_SETTING.SETUP._FILE_WAIT_');
                return;
            }

            if (this.uploadedFileCount() === 0) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.info, 'COMPANY_SETTING.SETUP._NO_FILES_' );
                return;
            }

            this.settingUp = true;
            this.CompaniesManager.accountSettupAssetsReady(this.company, this.files).then(
                function success(resp) {
                    this.settingUp = false;
                    this.setupDone = true;
                    this.OnboardingService.onAccountSetupFilesUploaded();
                    this.AbTestService.onAccountSetup();
                }.bind(this),
                function error(resp) {
                    this.settingUp = false;
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'COMPANY_SETTING.SETUP._FILE_ERROR_');
                }.bind(this)
            );
        },

        doneWelcome: function doneWelcome() {
            this.AnalyticsService.trackClick(this, "start account setup");
            this.isShowWelcomePage = false;

            this.$("html, body").animate({ scrollTop: 0 }, 200);
        },

        close: function close() {
            this.goAwayFromHere();
        },

        goAwayFromHere: function goAwayFromHere() {
            if (this.$state.previous) {
                this.NavigationService.goHistoryBack();
            }
            else {
                this.goToState(this.AppStates.root_core_navigation_home);
            }
        },
    });
}());